import { render, staticRenderFns } from "./Claim.vue?vue&type=template&id=677620c8&scoped=true"
import script from "./Claim.vue?vue&type=script&lang=js"
export * from "./Claim.vue?vue&type=script&lang=js"
import style0 from "./Claim.vue?vue&type=style&index=0&id=677620c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677620c8",
  null
  
)

export default component.exports